import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TermsOfUseComponent } from 'src/app/modules/policies/terms-of-use/terms-of-use.component';
import { CookieNoticeComponent } from './cookie-notice/cookie-notice.component';
import { PoliciesRoutePaths } from './policies-route-paths';
import { PrivacyNoticeComponent } from './privacy-notice/privacy-notice.component';
import { ConsumerHealthDataComponent } from './consumer-health-data/consumer-health-data.component';

const routes: Routes = [
  { path: PoliciesRoutePaths.termsOfUse, component: TermsOfUseComponent },
  { path: PoliciesRoutePaths.privacyNotice, component: PrivacyNoticeComponent },
  { path: PoliciesRoutePaths.consumerHealthData, component: ConsumerHealthDataComponent },
  { path: PoliciesRoutePaths.cookieNotice, component: CookieNoticeComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PoliciesRoutingModule {}
